(function () {
    'use strict';

    angular
        .module('cacmEventModule')
        .controller('cacmEventResultListController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {
        // Go To Event
        $scope.goToEvent = function (event) {
            if (!$scope.selectionService.selectionMode) {
                $scope.clickOnBox({event: event});
            }
        };

        $scope.selectionService = $scope.boxContext.selectionService;

    }
})();